'use client';
import { Button } from '@/components/ui/button';
import { useState } from 'react';
import ServicesSection from './servicessection';
import MobileServicesSection from './mobile-servicessection';

const tabs = ['PARA VOCÊ', 'PARA SUA EMPRESA'];

export default function OurServicesMain() {
  const [currTab, setCurrTab] = useState(1);

  return (
    <div className="w-full">
      {/* Navigation */}
      <div className="flex flex-row justify-center items-center my-6 lg:my-14">
        <div
          className={
            'flex w-full lg:w-5/12 items-center gap-3 p-2 rounded-xl border border-stone-400'
          }
        >
          {tabs.map((item, idx) => (
            <Button
              key={idx}
              onClick={() => {
                setCurrTab(idx);
              }}
              variant={'ghost'}
              className={`btn px-8 py-7 font-bold w-[50%] ${currTab == idx ? 'bg-bluecaixa text-white' : ''}`}
            >
              {item}
            </Button>
          ))}
        </div>
      </div>

      <div className="flex flex-row">
        <ServicesSection category_index={currTab} />
        <MobileServicesSection category_index={currTab} />
      </div>
    </div>
  );
}
